module.exports = __webpack_public_path__ + "img/bottomclound.30530d57.png";